export default __webpack_public_path__ + "static/media/Bears.9c99c206.png";